import Script from 'next/script';
import { GOOGLE_PLATFORM_SRC } from '@/utils/googleCustomerReviews';

export default function GoogleReviewBadge() {
  const renderBadge = () => {
    window.gapi?.load('ratingbadge', () => {
      if (document.getElementById('google-rating-badge-container')) return;
      const container = document.createElement('div');
      container.id = 'google-rating-badge-container';
      document.body.appendChild(container);
      window.gapi?.ratingbadge.render(container, {
        merchant_id: '7552790',
        position: 'BOTTOM_LEFT',
      });
    });
  };
  return (
    <Script
      src={GOOGLE_PLATFORM_SRC}
      strategy="lazyOnload"
      onLoad={renderBadge}
      onReady={renderBadge}
    />
  );
}
